import { connect } from 'react-redux'
import requestChangeNoteContent from '../sagas/requestChangeNoteContent'
import noteSelector from './noteSelector'
import Note from './Note'
import { withCardContext } from 'dataProviders/Card'

export default withCardContext(connect(
  noteSelector,
  {
    requestChangeNoteContent
  },
  null,
  {
    forwardRef: true,
  }
)(Note))
